import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ProgressBar from 'src/components/ui/Features/ProgressBar/ProgressBar';
import { useLearning } from 'src/hook/data/useLearning';
import useUser from 'src/hook/data/useUser';
import { useIFrameModal } from 'src/hook/modal/useIFrameModal';
import { GetRazorSiteUrl } from 'src/utils/URLUtils';
import Avatar from './Avatar/Avatar';
import styles from './ProgressHeader.module.scss';

const ProgressHeader = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { userInfo } = useUser();
    const { open } = useIFrameModal();
    const { learningInfo } = useLearning();
    const knownCount = learningInfo?.KnownWordIds?.length || 0;
    const unknownCount = (learningInfo?.UnknownWordIds?.length || 0) - (learningInfo?.ToLearn?.length || 0);
    const remainCount = learningInfo?.ToLearn?.length || 0;
    const uncoveredCount = knownCount + unknownCount + remainCount;

    return (
        <section className={styles.progressHeader}>
            {/* <img className={styles.backGroundImage} src={ImageLocation('discover-gesture.png')} alt="logo" /> */}
            <div className={styles.content}>
                <div className={styles.avatarSection}>
                    <Avatar />
                    <div className={styles.textContent}>
                        <h2>{t('Words')}</h2>
                        <h2>{t('Uncovered')}</h2>
                    </div>
                    <h1 className={styles.uncoverCount}
                        onClick={() => open(GetRazorSiteUrl('discover/word-list-fullmap', userInfo?.Token), t('Full knowledge map'))}>
                        {uncoveredCount.toLocaleString()}</h1>
                </div>
                <ProgressBar
                    knownCount={knownCount}
                    unknownCount={unknownCount}
                    remainCount={remainCount}
                    unknownColor='#D692FA'
                    remainColor='#AE24F6'
                    height={7} />
                <div className={styles.dataSection}>
                    <div className={styles.dataItem}>
                        <h3 className={styles.knewTitle}
                            onClick={() => navigate('/home/listview?id=-100')}>
                            {t('Knew') + ' ' + knownCount}</h3>
                        <h3 className={styles.toLearnTitle}
                            onClick={() => navigate('/home/listview?id=-101')}>
                            {t('To Learn') + ' ' + remainCount}</h3>
                    </div>
                    <div className={styles.dataItem}>
                        <h3 className={styles.learningTitle}
                            onClick={() => navigate('/home/listview?id=-102')}>
                            {t('Started') + ' ' + unknownCount}</h3>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProgressHeader;